import { createSlice } from "@reduxjs/toolkit";

export const masterCommonSlice = createSlice({
  name: "masterCommonSlice",
  initialState: {
    awsData: "default",
    recuitmentStatus: [
      "Applied",
      "Screened",
      "Interviewed",
      "Offer",
      "Hired",
      "Rejected",
    ],
  },

  reducers: {
    setAwsConfigData: (state, action) => {
      state.awsData = action.payload;
    },
  },
});

export const { setAwsConfigData } = masterCommonSlice.actions;

export default masterCommonSlice.reducer;
